import Vue from 'vue'
import McMessageDialog from '@/components/McMessageDialog'

let instance = null
let container = null

function createInstance() {
  if (instance) return instance

  container = document.createElement('div')
  document.body.appendChild(container)

  const Component = Vue.extend(McMessageDialog)
  instance = new Component({
    el: container,
    propsData: {
      value: false,
    },
  })

  instance.$on('primary-click', () => {
    if (instance._resolve) instance._resolve('primary')
    hideInstance()
  })

  instance.$on('secondary-click', () => {
    if (instance._resolve) instance._resolve('secondary')
    hideInstance()
  })

  instance.$on('cancel', () => {
    if (instance._resolve) instance._resolve('cancel')
    hideInstance()
  })

  return instance
}

function hideInstance() {
  if (!instance) return
  instance._resolve = null
  Vue.nextTick(() => {
    if (instance) {
      instance.$props.value = false
    }
  })
}

function show(options = {}) {
  const vm = createInstance()

  vm.$props.value = false

  return new Promise((resolve) => {
    Vue.nextTick(() => {
      const propsKeys = [
        'title',
        'subtitle',
        'content',
        'variant',
        'size',
        'centered',
        'hideIcon',
        'noCloseOnBackdrop',
        'noCloseOnEsc',
        'primaryButton',
        'secondaryButton',
        'modalHeight',
        'useHtml',
      ]

      propsKeys.forEach((key) => {
        if (options[key] !== undefined) {
          vm.$props[key] = options[key]
        } else if (vm.$options.props[key] && vm.$options.props[key].default !== undefined) {
          const def = vm.$options.props[key].default
          vm.$props[key] = typeof def === 'function' ? def() : def
        }
      })

      vm._resolve = resolve
      Vue.nextTick(() => {
        vm.$props.value = true
      })
    })
  })
}

function hide() {
  hideInstance()
}

export default {
  install(Vue) {
    Vue.prototype.$mcMessageDialog = {
      show,
      hide,
      error(options) {
        return show({ ...options, variant: 'error' })
      },
      success(options) {
        return show({ ...options, variant: 'success' })
      },
      warning(options) {
        return show({ ...options, variant: 'warning' })
      },
      info(options) {
        return show({ ...options, variant: 'info' })
      },
    }
  },
}

export { show, hide }
